import { render, staticRenderFns } from "./ShippingLayout.vue?vue&type=template&id=b84c8614&scoped=true&"
import script from "./ShippingLayout.vue?vue&type=script&lang=js&"
export * from "./ShippingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84c8614",
  null
  
)

export default component.exports